import { useEffect, useRef, useCallback } from 'react';

/**
 * Poll a callback at a fixed interval. Pauses when the tab is hidden.
 * Returns a manual refresh trigger.
 */
export function usePolling(callback: () => void, intervalMs = 12_000) {
    const savedCb = useRef(callback);
    savedCb.current = callback;

    const refresh = useCallback(() => savedCb.current(), []);

    useEffect(() => {
        savedCb.current();
        const id = setInterval(() => {
            if (!document.hidden) savedCb.current();
        }, intervalMs);
        return () => clearInterval(id);
    }, [intervalMs]);

    return refresh;
}
